import { useAuthentication } from '@hooks/interview/useAthentication';
import { useGetPath } from '@hooks/interview/useGetPath';
import { useInterviewAPI } from '@hooks/interview/useInterviewAPI';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { useMeetingSession } from '@hooks/meeting/useMeetingSession';
import { useBrowser } from '@hooks/utils/useBrowser';
import { MeetingMode } from '@interfaces/chime.enum';
import { useMeetingManager } from '@providers/MeetingProvider';
import { externalApiUrl } from '@stores/atoms/url';
import { useSetAtom } from 'jotai';
import { useEffect, type FC } from 'react';
import { useNavigate } from 'react-router';
import { Container } from './style';

const IntervieweeHomePage: FC = () => {
  const setExternalApiUrl = useSetAtom(externalApiUrl);
  const navigate = useNavigate();
  const meetingManager = useMeetingManager();
  const { initialize } = useMeetingSession(meetingManager);
  const { browserHelper } = useBrowser();
  const { rootPath } = useGetPath();
  const { getInterviewInfo, saveInterviewInfo } = useInterviewSession();
  const { fetchJoinInterview } = useInterviewAPI();
  const { authenticateUser } = useAuthentication();

  const handleError = (error?: unknown) => {
    console.log(error);
    alert(error);
    navigate('/error', { replace: true });
  };

  const initSession = async () => {
    if (!browserHelper.checkChromeBrowser())
      return navigate(rootPath.CHECK_BROWSER, {
        replace: true,
      });

    try {
      saveInterviewInfo();

      const { name, certificationCode, valuerSn, apiUrl } = getInterviewInfo();
      if (!name || !certificationCode)
        return handleError('이름과 응시코드를 확인하세요.');

      const externalApiAddr = `https://${apiUrl}`;
      setExternalApiUrl(externalApiAddr);

      // console.log('================================');
      // console.log('name:', name);
      // console.log('certificationCode:', certificationCode);
      // console.log('valuerSn:', valuerSn);
      // console.log(`고정 주소: ${externalApiAddr}`);
      // console.log('================================');

      const isAuthenticated = await authenticateUser({
        name,
        certificationCode,
        apiUrl: externalApiAddr,
      });

      if (!isAuthenticated) return handleError();

      if (!valuerSn) return handleError();

      const interviewSession = await fetchJoinInterview({
        name,
        certificationCode,
        valuerSn,
      });

      if (!interviewSession.status)
        return handleError('서버에러, 고객센터에 문의하세요.');

      const isInitReady = await initialize({
        JoinInfo: interviewSession.data.JoinInfo,
        meetingMode: MeetingMode.Attendee,
      });

      if (!isInitReady)
        return handleError('인터뷰 생성실패, 고객센터에 문의하세요.');

      navigate(rootPath.SETTING);
    } catch (error) {
      return handleError(error);
    }
  };

  useEffect(() => {
    (async () => await initSession())();
  }, []);

  return <Container />;
};

export default IntervieweeHomePage;
